module.exports = __webpack_public_path__ + "assets/img/es-a7ba11c0.png";